import {ChecklistTask} from '../types/ChecklistFormValue';

export const checklistTaskFactory = (): ChecklistTask => ({
  description: '',
  isMandatory: false,
  fileRequired: false,
});
